import type { VelocityModel } from '@core/core/types'
import { createSelector } from '@reduxjs/toolkit'

import { selectActiveProjectId } from '../project'
import type { RootState } from '../store'
import { velocityModelsAdapter } from './velocityModelsSlice'

const { selectEntities: selectVelocityModels } = velocityModelsAdapter.getSelectors<RootState>(
  state => state.velocityModels,
)

const EMPTY_MODELS: VelocityModel[] = []

export const selectVelocityModelsByActiveProject = createSelector(
  [selectVelocityModels, selectActiveProjectId],
  (velocityModels, activeProjectId) => {
    return velocityModels[activeProjectId]?.models ?? EMPTY_MODELS
  },
)
